<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <template v-slot:activator="{ on, attrs }">
      <v-btn depressed rounded small color="error" v-on="on" v-bind="attrs" text
        >Sair <v-icon class="ml-2" size="16">mdi-exit-to-app</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Sair do sistema</v-card-title>
      <v-card-text class="subtitle-1">
        Confirma o logout no sistema?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text rounded height="30" @click="sairSistema()" :loading="saindo"
          >Sim, sair</v-btn
        >
        <v-btn rounded text @click="dialog = false" height="30">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { setarUsuarioLogado } from '@/db/usuario'

export default {
  data: () => ({
    dialog: false,
    saindo: false,
  }),
  methods: {
    async sairSistema() {
      this.saindo = true;
      await setarUsuarioLogado(null);
      this.$router.go()
    },
  },
};
</script>

<style>
</style>